import {Box, CircularProgress} from "@mui/material";

export function SteddiButtonLoader() {
  return (
    <Box sx={{position: "absolute", top: 0, height: "100%", width: "100%", m: "0 -16px", background: "rgba(0, 0, 0, .1)"}} display="flex" alignItems="center" justifyContent="center">
      <CircularProgress size={25}/>
    </Box>
  )
}
